// Product card stagger animations
document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.product-grid .grid__item');
  
  productCards.forEach((card, index) => {
    card.style.setProperty('--index', index);
    card.style.animationDelay = `${index * 0.1}s`;
  });
  
  // Add click animation to buttons
  document.querySelectorAll('button, .button').forEach(button => {
    button.addEventListener('click', function(e) {
      const ripple = document.createElement('span');
      const rect = this.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;
      
      ripple.style.cssText = `
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 234, 0, 0.4);
        transform: scale(0);
        animation: ripple 0.6s linear;
        width: ${size}px;
        height: ${size}px;
        top: ${y}px;
        left: ${x}px;
        pointer-events: none;
      `;
      
      this.appendChild(ripple);
      setTimeout(() => ripple.remove(), 600);
    });
  });
});

// Add CSS for ripple effect
const style = document.createElement('style');
style.textContent = `
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  button, .button {
    position: relative;
    overflow: hidden;
  }
`;
document.head.appendChild(style);

function Delete_openTab(e,t){
  document.querySelectorAll('.tab-content').forEach(c=>c.classList.remove('active'));
  document.querySelectorAll('.tab-btn').forEach(b=>b.classList.remove('active'));
  document.getElementById(t).classList.add('active');
  e.currentTarget.classList.add('active');
}

// Auto-initialize all tab systems on the page
function initTabs() {
  const productDescriptions = document.querySelectorAll('.product__description');
  
  productDescriptions.forEach((container) => {
    const tabs = container.querySelectorAll('.tab-btn');
    const tabContents = container.querySelectorAll('.tab-content');
    
    if (tabs.length > 0) {
      let hasOnClickHandlers = false;
      tabs.forEach((tab) => {
        if (tab.getAttribute('onclick')) {
          hasOnClickHandlers = true;
        }
      });
      
      if (!hasOnClickHandlers) {
        let hasActiveTab = false;
        tabs.forEach((tab) => {
          if (tab.classList.contains('active')) {
            hasActiveTab = true;
          }
        });
        
        if (!hasActiveTab && tabs.length > 0) {
          tabs[0].classList.add('active');
        }
        
        if (!hasActiveTab && tabContents.length > 0) {
          tabContents[0].classList.add('active');
        }
        
        tabs.forEach((tab) => {
          tab.addEventListener('click', function(e) {
            let tabId = this.getAttribute('data-tab');
            
            if (!tabId) {
              const buttonText = this.textContent.trim().toLowerCase();
              if (buttonText === 'description') {
                tabId = 'desc';
              } else if (buttonText === 'specifications') {
                tabId = 'spec';
              }
            }
            
            if (tabId) {
              openTabInContainer(container, tabId);
            }
            
            tabs.forEach((btn) => btn.classList.remove('active'));
            this.classList.add('active');
          });
        });
      }
    }
  });
}

function openTabInContainer(container, tabId) {
  const tabContents = container.querySelectorAll('.tab-content');
  
  tabContents.forEach((content) => {
    if (content.id === tabId) {
      content.classList.add('active');
    } else {
      content.classList.remove('active');
    }
  });
}

function openTab(event, tabId) {
  const button = event.currentTarget || event.target;
  const container = button.closest('.product__description');
  
  if (container) {
    const tabs = container.querySelectorAll('.tab-btn');
    tabs.forEach((tab) => tab.classList.remove('active'));
    button.classList.add('active');
    
    const tabContents = container.querySelectorAll('.tab-content');
    tabContents.forEach((content) => {
      if (content.id === tabId) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTabs);
} else {
  initTabs();
}

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      initTabs();
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

// ============================================
// FIXED PRODUCT ZOOM FUNCTIONALITY
// ============================================
(function() {
  // Wait for everything to load
  function initProductZoom() {
    const zoomButtons = document.querySelectorAll('.product__media-toggle');
    
    if (zoomButtons.length === 0) {
      // Try again in a moment if buttons aren't found
      setTimeout(initProductZoom, 500);
      return;
    }
    
    zoomButtons.forEach(button => {
      // Remove any existing listeners to avoid duplicates
      button.removeEventListener('click', handleZoomClick);
      button.addEventListener('click', handleZoomClick);
    });
  }
  
  function handleZoomClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Find the image to zoom
    const mediaContainer = this.closest('.product-media-container');
    let imageSrc = null;
    
    if (mediaContainer) {
      const img = mediaContainer.querySelector('img');
      if (img && img.src) {
        imageSrc = img.src;
      }
    }
    
    // If not found, try to find any product image
    if (!imageSrc) {
      const productImage = document.querySelector('.product__media img, .product-featured-media img');
      if (productImage && productImage.src) {
        imageSrc = productImage.src;
      }
    }
    
    if (imageSrc) {
      openZoomLightbox(imageSrc);
    }
  }
  
  function openZoomLightbox(imageSrc) {
    // Remove existing lightbox if any
    const existingLightbox = document.querySelector('.product-zoom-lightbox');
    if (existingLightbox) {
      existingLightbox.remove();
    }
    
    // Create lightbox
    const lightbox = document.createElement('div');
    lightbox.className = 'product-zoom-lightbox';
    lightbox.innerHTML = `
      <div class="product-zoom-overlay"></div>
      <div class="product-zoom-container">
        <button class="product-zoom-close" aria-label="Close zoom">&times;</button>
        <img src="${imageSrc}" alt="Product zoom view">
      </div>
    `;
    
    document.body.appendChild(lightbox);
    document.body.style.overflow = 'hidden';
    
    // Close function
    const closeLightbox = () => {
      lightbox.remove();
      document.body.style.overflow = '';
    };
    
    // Add close event listeners
    const closeBtn = lightbox.querySelector('.product-zoom-close');
    const overlay = lightbox.querySelector('.product-zoom-overlay');
    
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (overlay) overlay.addEventListener('click', closeLightbox);
    
    // Close on ESC key
    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        closeLightbox();
        document.removeEventListener('keydown', escHandler);
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductZoom);
  } else {
    initProductZoom();
  }
  
  // Also watch for dynamically added content (like quick shop modals)
  const zoomObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initProductZoom();
      }
    });
  });
  
  zoomObserver.observe(document.body, { childList: true, subtree: true });
})();

// Fix Judge.me initialization (if needed)
if (typeof jdgm !== 'undefined' && jdgm) {
  jdgm._setupYtInput = jdgm._setupYtInput || function() {};
  console.log('Judge.me fix applied');
}


// Simple version - just makes tabs work
function openTab(event, tabId) {
  // Find the container
  let container = event.currentTarget.parentElement.parentElement;
  
  // Update button styles
  const buttons = container.querySelectorAll('button');
  buttons.forEach(btn => {
    btn.style.backgroundColor = '#f5f5f5';
    btn.style.fontWeight = 'normal';
  });
  //event.currentTarget.style.backgroundColor = '#007bff';
  //event.currentTarget.style.color = 'white';
  event.currentTarget.style.fontWeight = 'bold';
  
  // Show/hide content
  const descDiv = container.querySelector('#desc');
  const specDiv = container.querySelector('#spec');
  
  if (tabId === 'desc') {
    if (descDiv) descDiv.style.display = 'block';
    if (specDiv) specDiv.style.display = 'none';
  } else {
    if (descDiv) descDiv.style.display = 'none';
    if (specDiv) specDiv.style.display = 'block';
  }
}



document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".product__media img").forEach(img => {

        if (img.complete) {
            img.classList.add("loaded");
        } else {
            img.addEventListener("load", () => {
                img.classList.add("loaded");
            });
        }

    });
});